module.exports = __webpack_public_path__ + "static/kuat_detergent_lemonzest-25980322acf389a6f87d08ab0469b341.png";